<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown
                        field="SourceAlvId"
                        :label="$t('lang_GENERIC_CAPTION_SOURCE')"
                        :items="sourceOptions"
                        :context="context"
                        :withMargin="false"
                        :alvqa="alvqa + '-dropdown-source'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageTextField
                        :context="context"
                        field="OtherId"
                        :label="$t('lang_LABEL_TRACKS_CAPTION_OTHER_ID')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-other-id'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "TracksOtherIdsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "TracksOtherIds",
            alvqa: "label-tracks-edit-form-other-ids-panel-editing-dialog"
        }
    },
    computed: {
        sourceOptions() {
            return this.$store.getters.getAzForOtherIdsSource
        },
    },
}
</script>
